import { Tracker } from '@formily/reactive';
import { getCurrentInstance, onBeforeUnmount, isVue3 } from 'vue-demi';
/* istanbul ignore next */
export var useObserver = function (options) {
    if (isVue3) {
        var vm_1 = getCurrentInstance();
        var tracker_1 = null;
        var disposeTracker_1 = function () {
            if (tracker_1) {
                tracker_1.dispose();
                tracker_1 = null;
            }
        };
        var vmUpdate_1 = function () {
            var _a;
            (_a = vm_1 === null || vm_1 === void 0 ? void 0 : vm_1.proxy) === null || _a === void 0 ? void 0 : _a.$forceUpdate();
        };
        onBeforeUnmount(disposeTracker_1);
        Object.defineProperty(vm_1, 'effect', {
            get: function () {
                // https://github.com/alibaba/formily/issues/2655
                return vm_1['_updateEffect'] || {};
            },
            set: function (newValue) {
                vm_1['_updateEffectRun'] = newValue.run;
                disposeTracker_1();
                var newTracker = function () {
                    tracker_1 = new Tracker(function () {
                        if ((options === null || options === void 0 ? void 0 : options.scheduler) && typeof options.scheduler === 'function') {
                            options.scheduler(vmUpdate_1);
                        }
                        else {
                            vmUpdate_1();
                        }
                    });
                };
                var update = function () {
                    var refn = null;
                    tracker_1 === null || tracker_1 === void 0 ? void 0 : tracker_1.track(function () {
                        refn = vm_1['_updateEffectRun'].call(newValue);
                    });
                    return refn;
                };
                newTracker();
                newValue.run = update;
                vm_1['_updateEffect'] = newValue;
            },
        });
    }
};
//# sourceMappingURL=useObserver.js.map